import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import classNames from 'classnames';
import i18n from '../../i18n';
import Button from '../Button';
import styles from './ListOccurrences.module.scss';

const ListOccurrences = ({ occurrences = [] }) => {
    const [occurrencesVisible, setOccurrencesVisible] = useState(3);
    const firstDate = occurrences[0]?.date;
    const lastDate = occurrences[occurrences.length - 1]?.date;
    return (
        <div className={styles['ListOccurrences']}>
            <h2 className={styles['ListOccurrences__Title']}>
                {i18n.t('EventPage.allDatesHeader')}
            </h2>
            {/* {occurrences.length > 1 && firstDate && lastDate && (
                <p className={styles['ListOccurrences__Label']}>
                    {dayjs(firstDate).format('D MMM')} —{' '}
                    {dayjs(lastDate).format('D MMM YYYY')}
                </p>
            )} */}

            <Occurrences
                showMoreButtonIsVisible={
                    occurrences.length > occurrencesVisible
                }
                items={occurrences.slice(0, occurrencesVisible)}
            />
            {occurrences.length > occurrencesVisible && (
                <Button
                    type="tertiary"
                    icon="plus"
                    iconColor="pink"
                    iconDirection="left"
                    text={i18n.t('EventPage.allDatesMore')}
                    modifiers={[styles['ListOccurrences__More']]}
                    onClick={() =>
                        setOccurrencesVisible(occurrencesVisible + 20)
                    }
                />
            )}
        </div>
    );
};

const Occurrences = ({ items, showMoreButtonIsVisible }) => (
    <table
        className={classNames(styles['ListOccurrences__List'], {
            [styles['ListOccurrences__List--NoButton']]:
                !showMoreButtonIsVisible,
        })}>
        <tbody className={styles['ListOccurrences__ListContent']}>
            <tr className="sr-only">
                <th scope="col">Date</th>
                <th scope="col">Time</th>
            </tr>
            {items.map((item, i) => (
                <tr key={i} className={styles['ListOccurrences__Row']}>
                    <td className={styles['ListOccurrences__RowItem']}>
                        {dayjs(item.date).format('D MMMM')}
                    </td>
                    {item?.startTime && item?.endTime && (
                        <td className={styles['ListOccurrences__RowItem']}>
                            {item?.startTime && item.startTime.slice(0, 5)} –{' '}
                            {item?.endTime && item.endTime.slice(0, 5)}
                        </td>
                    )}
                </tr>
            ))}
        </tbody>
    </table>
);

ListOccurrences.propTypes = {
    occurrences: PropTypes.array,
};

export default ListOccurrences;
